define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var proofTemplateAdmin = ['Proof Template Administrator'];

	csiAccess.addViewRoles({
		"_CS_Data":{
			"ProofingTemplates": {
				"NewProofTemplate":access(full(proofTemplateAdmin)),
			},
		},
	});
});